<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 简历投递
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container'>
            <div class='handle-box'>
                <!--                <el-button-->
                <!--                    type='primary'-->
                <!--                    icon='el-icon-plus'-->
                <!--                    class='handle-del mr10'-->
                <!--                    @click='addUser'-->
                <!--                >添加服务商-->
                <!--                </el-button>-->
                <el-select v-model="provinceValue" placeholder="请选择省份" class='handle-select mr10'>
                    <el-option
                        v-for="item in provinceOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="cityValue" placeholder="请选择市" class='handle-select mr10'>
                    <el-option
                        v-for="item in cityOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="areaValue" placeholder="请选择区" class='handle-select mr10'>
                    <el-option
                        v-for="item in areaOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model='enterpiseValue' placeholder='企业' style='width: 140px;margin-right: 20px'>
                    <el-option
                        v-for='item in enterpiseOptions'
                        :key='item.value'
                        :label='item.label'
                        :value='item.value'>
                    </el-option>
                </el-select>

                <el-cascader
                    v-model='workType'
                    :options='options'
                    style='width: 260px'
                    class='handle-input mr10'
                    placeholder='请选择岗位类型'
                    clearable
                    @change='handleChange'></el-cascader>

<!--                <el-input v-model='query.name' placeholder='用户名' class='handle-input mr10'-->
<!--                          style='width: 160px'></el-input>-->
                <el-button type='primary' icon='el-icon-search' @click='handleSearch'>查询</el-button>
                <!--                <el-button type='primary' icon='el-icon-add' @click='handleAdd'>添加</el-button>-->
            </div>
            <el-table
                :data='tableData'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >

                <el-table-column label='序号' align='center' :index='indexMethod' type='index' width='40'>
                </el-table-column>
                <el-table-column type='selection' width='55' align='center' v-if='false'></el-table-column>
                <el-table-column prop='name' label='用户名' align='center'>
                    <template slot-scope='scope'>{{ scope.row.userName }}</template>
                </el-table-column>
                <el-table-column prop='area' label='招聘企业' align='center'>
                    <template slot-scope='scope'>{{ scope.row.enterpriseName }}</template>

                </el-table-column>
                <el-table-column prop='area' label='招聘岗位' align='center'>
                    <template slot-scope='scope'>{{ scope.row.workName }}</template>

                </el-table-column>
                <el-table-column prop='area' label='省市区' align='center'>
                    <template slot-scope='scope'>{{ scope.row.provinceName }}{{ scope.row.cityName }}{{ scope.row.areaName }}</template>

                </el-table-column>
                <el-table-column prop='area' label='详细地址' align='center'>
                    <template slot-scope='scope'>{{ scope.row.addressDetail }}</template>

                </el-table-column>
                <el-table-column prop='area' label='求职类型' align='center'>
                    <template slot-scope='scope'>{{ scope.row.postType === 0 ? '全职' : '兼职' }}</template>

                </el-table-column>
                <el-table-column prop='area' label='学历要求' align='center'>
                    <template slot-scope='scope'>{{ scope.row.educationName }}</template>

                </el-table-column>
                <el-table-column prop='area' label='求职类型' align='center'>
                    <template slot-scope='scope'>{{ scope.row.postType === 0 ? '全职' : '兼职' }}</template>

                </el-table-column>
                <el-table-column label='工作经验' align='center'>
                    <template slot-scope='scope'>{{ scope.row.workTimeName }}</template>
                </el-table-column>




                <el-table-column prop='createTime' label='投递时间' align='center'>
                    <template slot-scope='scope'>{{ scope.row.createTime }}</template>

                </el-table-column>
                <el-table-column label='操作' width='180' align='center'>
                    <template slot-scope='scope'>
                        <el-button
                            type='text'
                            icon='el-icon-edit'
                            @click='handleEdit(scope.$index, scope.row)'
                        >查看简历
                        </el-button>
                        <el-button
                            type='text'
                            v-if='false'
                            icon='el-icon-delete'
                            class='red'
                            @click='handleDelete(scope.$index, scope.row)'
                        >删除
                        </el-button>
                        <!--                        <el-button-->
                        <!--                            type='text'-->
                        <!--                            class='blue'-->
                        <!--                            @click='handleForbidden(scope.$index, scope.row)'-->
                        <!--                        >{{ scope.row.status === 0 ? '禁用' : '解除禁用' }}-->
                        <!--                        </el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page='query.pageIndex'
                    :page-size='query.pageSize'
                    :total='pageTotal'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog title='查看简历' :visible.sync='editVisible' width='40%'>


            <el-form ref='form' :model='form' label-width='120px'>
                <el-form-item label='用户头像'>
                    <el-upload
                        disabled
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='form.photoUrls'
                        limit='1'
                        action='https://jsonplaceholder.typicode.com/posts/'
                        :http-request='uploadFileCovenant'
                        list-type='picture'>
                        <el-button size='small' type='primary' disabled>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>

                <el-form-item label='姓名'>
                    <el-input v-model='form.name' maxlength='11' disabled></el-input>
                </el-form-item>
                <el-form-item label='电话'>
                    <el-input v-model='form.phone' maxlength='11' disabled></el-input>
                </el-form-item>
                <el-form-item label='性别'>
                    <el-radio-group v-model='form.sex' disabled>
                        <el-radio :label='0'>女</el-radio>
                        <el-radio :label='1'>男</el-radio>

                    </el-radio-group>
                </el-form-item>
                <el-form-item label='婚姻状况' >
                    <el-radio-group v-model='form.marriageStatus' disabled>
                        <el-radio :label='0'>未婚</el-radio>
                        <el-radio :label='1'>已婚</el-radio>

                    </el-radio-group>
                </el-form-item>
                <el-form-item label='出生年月'>
                    <el-date-picker
                        disabled
                        v-model='form.birthday'
                        type='date'
                        placeholder='选择日期'>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label='最高学历'>
                    <el-select v-model='form.educationRank' placeholder='请选择学历' class='handle-select mr10' disabled>
                        <el-option key='0' label='高中以下' value='0'></el-option>
                        <el-option key='1' label='高中' value='1'></el-option>
                        <el-option key='2' label='中专/技校' value='2'></el-option>
                        <el-option key='3' label='大专' value='3'></el-option>
                        <el-option key='4' label='大学' value='4'></el-option>
                        <el-option key='5' label='硕士' value='5'></el-option>
                        <el-option key='6' label='博士' value='6'></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='求职类型'>
                    <el-select v-model='form.postType' placeholder='请选择求职类型' class='handle-select mr10' disabled>
                        <el-option key='0' label='全职' value='0'></el-option>
                        <el-option key='1' label='兼职' value='1'></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='期望薪资'>
                    <el-select v-model='form.salaryType' placeholder='请选择期望薪资' class='handle-select mr10' disabled>
                        <el-option key='0' label='面议' value='0'></el-option>
                        <el-option key='1' label='1000以下' value='1'></el-option>
                        <el-option key='2' label='1000-2000' value='2'></el-option>
                        <el-option key='3' label='2000-3000' value='3'></el-option>
                        <el-option key='4' label='3000-5000' value='4'></el-option>
                        <el-option key='5' label='5000-8000' value='5'></el-option>
                        <el-option key='6' label='8000-15000' value='6'></el-option>
                        <el-option key='7' label='15000以上' value='6'></el-option>

                    </el-select>
                </el-form-item>

                <el-form-item label='求职区域'>
                    <el-cascader
                        disabled
                        v-model='cityId'
                        :options='cityOptions'
                    ></el-cascader>
                </el-form-item>
                <el-form-item label='岗位类型'>
                    <el-cascader
                        disabled
                        v-model='workTypeIds'
                        :options='options'
                    ></el-cascader>
                </el-form-item>

                <el-form-item label='到岗时间'>
                    <el-select v-model='form.goWorkTime' placeholder='请选择学历' class='handle-select mr10' disabled>
                        <el-option key='0' label='随时' value='0'></el-option>
                        <el-option key='1' label='一周内' value='1'></el-option>
                        <el-option key='2' label='一个月内' value='2'></el-option>
                        <el-option key='3' label='已离职' value='3'></el-option>
                        <el-option key='4' label='可快速到岗' value='4'></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='工作经历'>
                    <el-input
                        disabled
                        type="textarea"
                        :rows="4"
                        placeholder="请输入内容"
                        v-model="form.workExperience">
                    </el-input>
                </el-form-item>
                <el-form-item label='教育经历'>
                    <el-input
                        disabled
                        type="textarea"
                        :rows="4"
                        placeholder="请输入内容"
                        v-model="form.educationExperience">
                    </el-input>
                </el-form-item>
                <el-form-item label='自我描述'>
                    <el-input
                        disabled
                        type="textarea"
                        :rows="4"
                        placeholder="请输入内容"
                        v-model="form.myselfDesc">
                    </el-input>
                </el-form-item>
            </el-form>

            <span slot='footer' class='dialog-footer'>
<!--                <el-button @click='editVisible = false'>取 消</el-button>-->
                <el-button type='primary' @click='editVisible = false'>确 定</el-button>
            </span>
        </el-dialog>

        <!-- 添加用户 -->
        <el-dialog title='添加人才' :visible.sync='addVisible' width='40%'>


            <el-form ref='form' :model='form' label-width='120px'>

                <el-form-item label='服务商名称'>
                    <el-input v-model='createForm.name' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='省市'>
                    <el-cascader
                        v-model='value'
                        :props='defaultParams'
                        :options='options'
                        @change='handleChange'></el-cascader>
                </el-form-item>
                <el-form-item label='联系人'>
                    <el-input v-model='createForm.concatName' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='联系电话'>
                    <el-input v-model='createForm.concatPhone' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='合同复印件'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='[createForm.covenantUrl]'
                        limit='1'
                        action='https://jsonplaceholder.typicode.com/posts/'
                        :http-request='uploadFileCovenant'
                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label='法人证件'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='[createForm.legalPersonUrl]'
                        limit='1'
                        action='https://jsonplaceholder.typicode.com/posts/'
                        :http-request='uploadFileLegalPerson'
                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>

                </el-form-item>
                <el-form-item label='组织机构代码证'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='[createForm.orzUrl]'
                        limit='1'
                        action='https://jsonplaceholder.typicode.com/posts/'
                        :http-request='uploadFileOrzUrl'
                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>

                </el-form-item>
                <el-form-item label='是否有客服'>
                    <el-radio v-model='radio' label='1'>是</el-radio>
                    <el-radio v-model='radio' label='0'>否</el-radio>
                </el-form-item>

            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='addVisible = false'>取 消</el-button>
                <el-button type='primary' @click='addUserHttp'>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { formatDate, formatDates } from '@/utils/formatDate';

export default {
    name: 'basetable',
    data() {
        return {
            enterpiseValue:"",
            queryEnterprise: {
                name: '',
                pageIndex: 1,
                pageSize: 999999
            },
            radio: '1',
            fileList: [],
            workType: '',
            value: [],
            options: [],
            query: {
                name: '',
                educationRank: '',
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible: false,
            provinceOptions: [],

            cityOptions:[],
            provinceValue: '',
            cityValue:"",
            areaOptions:[],
            areaValue:"",
            cityIds:[],
            workTypeIds:[],
            enterpiseOptions:[],


            createForm: {
                'concatPhone': '',
                'concatName': '',
                'name': '',
                'covenantUrl': '',
                'legalPersonUrl': '',
                'orzUrl': '',
                'isCustomerService': '1',
                'provinceId': '',
                'cityId': ''

            }
            ,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1

        };
    },
    created() {
        this.getData();
        this.getWorkTypeList();
        this.getProvince();
        // this.getCity();
    },

    watch: {

        //监听内容
        provinceValue() {
            this.enterpiseOptions=[]
            this.enterpiseValue=''
            let that = this;
            this.areaValue=''
            this.cityValue=''
            let param = {"id":this.provinceValue}
            this.http.get('user/getCity', param).then(res => {
                    if (res.code == 0) {
                        that.cityOptions = [{"id":"","name":"请选择市"},...res.data] ;
                        // that.pageTotal = parseInt(res.data.total);
                        // this.$message.success('获取数据成功');
                    }
                },
                err => {

                });
            this.getEnterpise();
            console.log("provinceValue"+this.provinceValue)
        },
        cityValue(){
            this.enterpiseOptions=[]
            this.enterpiseValue=''
            this.getEnterpise();
            let that = this;
            this.areaValue=''
            let param = {"id":this.cityValue}
            this.http.get('user/getAreaById', param).then(res => {
                    if (res.code == 0) {
                        that.areaOptions =[{"id":"","name":"请选择区"},...res.data] ;
                        // that.pageTotal = parseInt(res.data.total);
                        // this.$message.success('获取数据成功');
                    }
                },
                err => {

                });
        },
        areaValue(){
            this.enterpiseOptions=[]
            this.getEnterpise();
            this.enterpiseValue=''

            let that = this;

        }
    },
    methods: {
        indexMethod(index) {
            return index + 1;
        },
        handlePreview(file) {

        },
        uploadFileCovenant(file) {
            let that = this;
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);
                    that.form.photoUrls=[{url:that.http.getDownLoadUrl() + res.data.data[0]}]

                    that.form.photoUrl =that.http.getDownLoadUrl() +  res.data.data[0];
                }
            }, err => {
                // 出现错误时的处理
            });
        },
        uploadFileLegalPerson(file) {
            let that = this;
            this.http.postFile('/uploadFile', file.file).then(res => {
                // 上传成功后的处理
                console.log(res.data);
                if (res.data.code == 0) {
                    that.createForm.legalPersonUrl = res.data.data;
                    that.form.legalPersonUrl = res.data.data;
                }
            }, err => {
                // 出现错误时的处理
                console.log(res);
            });
        },
        getEnterpise() {
            let that = this;
            this.queryEnterprise.provinceId = this.provinceValue
            this.queryEnterprise.cityId = this.cityValue
            this.queryEnterprise.areaId = this.areaValue
            this.http.get('/qwpenterprise/getList', this.queryEnterprise).then(res => {
                    that.enterpiseOptions=[]
                    that.enterpiseOptions.push({ 'value': '', 'label': '请选择企业' });
                    if (res.code == 0) {
                        console.log("xxxxxxxxx")

                        res.data.records.forEach(res => {
                            that.enterpiseOptions.push({ 'value': res.id, 'label': res.name });
                        });

                    }
                },
                err => {


                });
        },
        uploadFileOrzUrl(file) {
            let that = this;
            this.http.postFile('/uploadFile', file.file).then(res => {
                // 上传成功后的处理
                console.log(res.data);
                if (res.data.code == 0) {
                    that.createForm.orzUrl = res.data.data;
                    that.form.orzUrl = res.data.data;

                }
            }, err => {
                // 出现错误时的处理
                console.log(res);
            });
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type.includes('image');
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('文件只能是图片格式');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        getProvince(){
            let that = this;
            console.log(this.query.pageSize);
            let param = {}
            this.http.get('user/getProvince', param).then(res => {
                    if (res.code == 0) {

                        that.provinceOptions =[{"id":"","name":"请选择省份"},...res.data] ;
                        // that.pageTotal = parseInt(res.data.total);
                        // this.$message.success('获取数据成功');
                    }
                },
                err => {

                });

        },

        // 获取 easy-mock 的模拟数据
        getData() {
            let that = this;
            if (this.workType.length != 0) {
                this.query.workTypeId = this.workType[2];
            }
            this.query.provinceId = this.provinceValue

            this.query.cityId = this.cityValue
            this.query.areaId = this.areaValue
            this.query.enterpriseId = this.enterpiseValue
            this.http.get('/workType/getList', this.query).then(res => {
                    if (res.code == 0) {
                        that.tableData = res.data.records;
                        that.pageTotal = parseInt(res.data.total);
                        this.$message.success('获取数据成功');

                    }
                },
                err => {

                });
        },
        getWorkTypeList() {
            let that = this;
            this.http.get('/workType/getWorkTypeList', {}).then(res => {
                    if (res.code == 0) {
                        that.options = res.data;

                    }
                },
                err => {

                });
        },

        getUserInfoById( id) {
            let that = this;
            let param = {};
            param.id = id
            this.http.get('/user/getUserInfoById', param).then(res => {
                    if (res.code == 0) {
                        that.form = res.data;
                        // this.form = JSON.parse(JSON.stringify(row));

                        that.form.sexName = this.form.sex == 0 ? '女' : '男';
                        that.form.educationRank = '' + this.form.educationRank;
                        that.form.goWorkTime = '' + this.form.goWorkTime;
                        that.form.photoUrls = [{ url: this.form.photoUrl }];
                        that.cityId = [that.form.provinceId, that.form.cityId];
                        that.form.postType=this.form.postType+""
                        console.log("start")

                        if (that.form.workTypeId!=null){
                            that.workTypeIds=[this.form.workOneLeaveTypeId+"",this.form.workTwoLeaveTypeId+"",this.form.workTypeId+""]
                        }else {
                            that.workTypeIds=[]
                        }
                        that.form.salaryType =that.form.salaryType+""


                        that.editVisible = true;
                    }
                },
                err => {

                });
        },
        // getCityBack() {
        //     let that = this;
        //     this.http.get('/user/getBackCity', {}).then(res => {
        //             if (res.code == 0) {
        //                 that.cityOptions = res.data;
        //
        //             }
        //         },
        //         err => {
        //
        //         });
        // },
        getCity() {
            let that = this;


            this.http.getToken('serviceProvider/getCity', this.query).then(res => {
                    if (res.code == 0) {
                        that.options = res.data;

                    }
                },
                err => {

                });
        },
        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex = 1;
            this.getData();

        },
        delUserHttp(id) {
            let that = this;
            this.http.post('user/delUserById', { 'id': id, 'status': 1 }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,

        editUserHttp(params) {
            let that = this;

            this.http.post('user/updateUserInfoByid', params).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        this.editVisible = false;
                        that.$message.success('编辑成功');
                    }
                },
                err => {

                });
        }
        ,
        handleAdd() {
            this.addVisible = true;
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },

        addUser() {
            this.createForm = {};
            this.value = [];
            this.addVisible = true;


        },

        addUserHttp() {
            if (this.value.length != 2) {
                this.$message.error('省市未选择');
                return;
            }
            this.createForm.provinceId = this.value[0];
            this.createForm.cityId = this.value[1];
            this.createForm.isCustomerService = this.radio;

            let that = this;
            this.http.postToken('serviceProvider/add', this.createForm).then(res => {
                if (res.code === 0) {
                    that.getData();
                    that.addVisible = false;
                }

            });
        }
        ,
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
            }
            this.$message.error(`删除了${str}`);
            this.multipleSelection = [];
        },
        //禁用
        handleForbidden(index, row) {
            // 二次确认删除
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';
            if (row.status == 0) {
                msg = '确定要' + '禁用' + '吗？';
                params = { 'id': row.id, 'status': 2 };
            } else {
                msg = '确定要' + '解除禁用' + '吗？';
                params = { 'id': row.id, 'status': 0 };
            }

            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.postToken('serviceProvider/updateStatus', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        // 编辑操作
        handleEdit(index, row) {
            this.getUserInfoById(row.userId)

        },
        // 保存编辑
        saveEdit() {
            if (this.cityId==null || this.cityId.length==0){
                this.$message.error("求职地址不能为空")
                return
            }
            if (this.workTypeIds==null || this.workTypeIds.length==0){
                this.$message.error("求职地址不能为空")
                return
            }
            this.form.city_id=this.cityId[1]
            this.form.workTypeId=this.workTypeIds[2];
            this.editUserHttp(this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
